import { ComponentMultiStyleConfig } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';
import { rgba } from 'polished';

import COLORS from 'theme/colors';

const AccordionTheme: ComponentMultiStyleConfig = {
  parts: ['popper', 'content', 'header', 'body', 'footer', 'arrow', 'closeButton'],
  baseStyle: props => {
    const { variant } = props;

    return {
      root: {
        borderColor: mode('silver.base', 'grey.base')(props)
      },
      button: {
        position: 'relative',
        padding: '8px 12px',
        textAlign: 'left',
        color: mode('black.lighter', 'silver.light')(props),
        p: {
          color: mode('grey.base', 'grey.lightest')(props)
        },
        '> svg': {
          // accordion chevron
          alignSelf: 'flex-start',
          transition: 'transform 0.2s ease 0s'
        },
        '&[aria-expanded=true]': {
          '> svg': {
            transform: 'rotate(-180deg)'
          }
        },
        _hover: {
          backgroundColor: mode(rgba(COLORS.black.base, 0.04), rgba(COLORS.silver.lightest, 0.08))(props)
        },
        _focus: {
          boxShadow: 'none'
        },
        ':focus-visible': {
          boxShadow: 'none',
          _after: {
            content: '""',
            width: '100%',
            height: '100%',
            position: 'absolute',
            boxShadow: `inset 0px 0px 0px 3px ${COLORS.blue.lighter}`,
            ...(variant !== 'flush' && {
              marginLeft: '-12px'
            })
          }
        },
        '~ *': {
          // accordion panel
          color: mode('black.lighter', 'silver.lighter')(props)
        },
        _disabled: {
          color: mode('grey.lighter', 'grey.light')(props),
          p: {
            color: mode('grey.lighter', 'grey.light')(props)
          },
          '~ *': {
            // accordion panel
            color: mode('grey.lighter', 'grey.light')(props)
          }
        }
      },
      panel: {
        padding: '0 12px 12px'
      }
    };
  },
  variants: {
    flush: {
      button: {
        paddingLeft: '0px',
        paddingRight: '0px'
      },
      panel: {
        paddingLeft: '0px',
        paddingRight: '0px'
      }
    }
  }
};

export default AccordionTheme;
